import React from "react";
import { Box, Divider } from "@mui/material";

import CustomerShipmenItems from "./CustomerShipmenItems";

// No fetching here — the shipments table below fetches (with pagination) and
// reports the total back up via setTotalShipments.
const CustomerShipmentTab = ({ setTotalShipments }) => {
  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}></Box>
      <Divider />

      <CustomerShipmenItems setTotalShipments={setTotalShipments} />
    </>
  );
};

export default CustomerShipmentTab;
